import React from 'react'

export default function Result() {
  return (
    <div>
        This is the results
    </div>
  )
}
